var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, isValidElement } from "react";
import useUniqueId from "../../hooks/useUniqueId";
import useIdAttrs from "../../hooks/useIdAttrs";
import { ExpandActionBox, PrimaryActionBox, StyledExpandableContainer, StyledMainTitle, StyledSecondaryTitle, StyledTitleContainer, StyledToolbar, } from "./TitleBar.style";
import Flex from "../box/Flex";
import { apolloSpaceInline1X } from "@nexthink/apollo-tokens";
import Button from "../button/Button";
import Collapsible from "../collapsible/Collapsible";
import ContextActionMenu from "../menu/ContextActionMenu";
import KebabActionMenu from "../menu/KebabActionMenu";
const prefixId = "nx-title-bar";
const TitleBar = (_a) => {
    var { id, "data-insights": insightsAttr, mainTitle, secondaryTitle, mainActions, expandableContent, isExpanded, onExpandClick, expandButtonLabel, titleActions } = _a, rest = __rest(_a, ["id", "data-insights", "mainTitle", "secondaryTitle", "mainActions", "expandableContent", "isExpanded", "onExpandClick", "expandButtonLabel", "titleActions"]);
    id = useUniqueId(prefixId, id);
    const idAttrs = useIdAttrs({ id, insightsAttr });
    const expandableContainerId = `${id}-expandable-container`;
    return (React.createElement(Flex, { flexDirection: "column" },
        React.createElement(StyledToolbar, Object.assign({}, idAttrs(), rest),
            React.createElement(ContextActionMenu, { actions: titleActions },
                React.createElement(StyledTitleContainer, { flexDirection: "column-reverse", overflow: "hidden", flex: 1 },
                    React.createElement(Flex, { alignItems: "center" },
                        React.createElement(StyledMainTitle, Object.assign({}, idAttrs("-main"), { title: mainTitle }), mainTitle),
                        titleActions && (React.createElement(KebabActionMenu, { id: id, actions: titleActions, "aria-label": `Actions for ${mainTitle}` }))),
                    React.createElement(StyledSecondaryTitle, Object.assign({}, idAttrs("-secondary"), { title: secondaryTitle }), secondaryTitle))),
            React.createElement(Flex, { ml: apolloSpaceInline1X },
                Children.map(mainActions, (child) => isValidElement(child) ? React.createElement(PrimaryActionBox, null, child) : ""),
                expandButtonLabel && onExpandClick && (React.createElement(ExpandActionBox, null,
                    React.createElement(Button, Object.assign({}, idAttrs("-expand"), { key: "expand-action", "aria-label": expandButtonLabel, "aria-controls": expandableContainerId, "aria-expanded": isExpanded, title: expandButtonLabel, size: "small", pressed: isExpanded, onClick: onExpandClick, iconName: isExpanded ? "editorExpand" : "editorCollapse", variant: "secondary" })))))),
        React.createElement(Collapsible, { collapsed: !isExpanded, id: expandableContainerId, "data-insights": insightsAttr && `${insightsAttr}-expandable-container` },
            React.createElement(StyledExpandableContainer, null, expandableContent))));
};
export default TitleBar;
//# sourceMappingURL=TitleBar.js.map